import { useTheme } from "@emotion/react";
import VisibilityOff from "@mui/icons-material/VisibilityOffOutlined";
import Visibility from "@mui/icons-material/VisibilityOutlined";
import { FormControl } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import React, { useState } from "react";
import styled from "styled-components";
import { useApi } from "../../contexts/ApiContext";
import FormLabel from "../FormLabel";
import { InputProps } from "./InputProps";
const StyledTextField = styled(TextField)`
  margin: 8px 0;
  width: 100%;
`;

const PasswordInput: React.FC<InputProps> = ({
  label,
  value,
  onChange,
  error,
  helperText,
  topRight,
}) => {
  const theme: any = useTheme();
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const { isSubmitting, isLoading } = useApi();
  const isDisabled = isLoading || isSubmitting;

  const labelSx = topRight
    ? {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }
    : {};

  return (
    <FormControl fullWidth disabled={isDisabled}>
      <FormLabel sx={labelSx}>
        {label}
        {topRight}
      </FormLabel>

      <StyledTextField
        disabled={isDisabled}
        type={showPassword ? "text" : "password"}
        variant="outlined"
        fullWidth
        value={value}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          onChange(event.currentTarget.value as string)
        }
        error={error}
        helperText={error ? helperText : " "}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                edge="end"
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </FormControl>
  );
};

export default PasswordInput;
